import { Type } from "class-transformer";
import { serializeType } from "../classes/common";
import { Transaction } from '../enums/txn-type.enum';
import { isNullOrUndefined } from "@qntm-code/utils";

export class ApprovalRequest {
  refId: number;
  txnTypeId: number;
  transaction: Transaction;
  showStatusInDialog: boolean = true;       // true by default
  showStatusOnPage: boolean = false;        // false by default
  emitStatus: boolean = false;              // false by default

  // Todo refactor approval request call using constructor

  constructor (txnType?: Transaction, refId?: number, showStatusInDialog?: boolean, showStatusOnPage?: boolean, emitStatus?: boolean) {
    if (!isNullOrUndefined(txnType)) {
        this.transaction = txnType;
    }
    if (!isNullOrUndefined(refId)) { this.refId = refId; }
    if (!isNullOrUndefined(showStatusInDialog)) { this.showStatusInDialog = showStatusInDialog; }
    if (!isNullOrUndefined(showStatusOnPage)) { this.showStatusOnPage = showStatusOnPage; }
    if (!isNullOrUndefined(emitStatus)) { this.emitStatus = emitStatus; }
  }
}

// ToDo change this to Approval History
export class ApprovalStatus {
  actionBy: string;
  @Type(serializeType(Date)) actionOn: Date;
  actionTaken: string;
  responseMessage: string;
  workitemApprovalId: number;

  approverId: number;   // To denote userId of original Approver
  newApproverId: number;
}


export class WorkitemApprovalSummary {
  approvals: any[];
}
